import React, { useState } from "react";
import { Typography, Box, Input, Button, Link } from "@mui/joy";
import axios from "axios";
import { useNavigate, Link as RouterLink } from "react-router-dom";
import NodeSphereIcon from "../components/icons/NodeSphereIcon";

export default function Register() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: "",
    country: "",
    skillTags: "",
    email: "",
    password: "",
    role: "worker", // defaultss
    telegram: "",
    twitter: "",
    phone: "",
  });
  const [message, setMessage] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
const API_URL = process.env.REACT_APP_API_URL;

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const {
        name,
        country,
        skillTags,
        email,
        password,
        role,
        telegram,
        twitter,
        phone,
      } = formData;

      // Only split skillTags if user is a "worker"
      const skillTagsArray =
        role === "worker"
          ? skillTags
              .split(",")
              .map((tag) => tag.trim())
              .filter((tag) => tag)
          : [];

     const response = await axios.post(`${API_URL}/api/register`, {
        name,
        country,
        email,
        password,
        role,
        telegram,
        twitter,
        phone,
        skillTags: skillTagsArray, // safe even if empty
      });

      setMessage(response.data.message);

      setFormData({
        name: "",
        country: "",
        skillTags: "",
        email: "",
        password: "",
        role: "worker", // default role
        telegram: "",
        twitter: "",
        phone: "",
      });

      setTimeout(() => navigate("/"), 2000); // Redirect to sign-in after 2s
    } catch (err) {
      setMessage(err.response?.data.message || "Error registering user");
    }
  };

  return (
    <Box
      sx={{
        maxWidth: 400,
        mx: "auto",
        p: 3,
        mt: 12,
        border: "1px solid #e0e0e0",
        borderRadius: "8px",
        boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
        backgroundColor: "#0d1117",
        color: "#ffffff",
      }}
    >
      <Typography level="h4" sx={{ mb: 3, textAlign: "center" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "0.5rem",
            marginBottom: "1rem",
          }}
        >
          <span
            style={{ color: "#ffffff", fontWeight: "bold", fontSize: "1.5rem" }}
          >
            Mosaic
          </span>
          <NodeSphereIcon className="spin-logo" />
          <span
            style={{ color: "#3b82f6", fontWeight: "bold", fontSize: "1.5rem" }}
          >
            Tech
          </span>
        </div>
        v Register with Mosaic Global Tech
      </Typography>
      <form onSubmit={handleSubmit}>
        <Input
          name="name"
          placeholder="Full Name"
          value={formData.name}
          onChange={handleChange}
          sx={{ mb: 2 }}
        />
        <Input
          name="country"
          placeholder="Country"
          value={formData.country}
          onChange={handleChange}
          sx={{ mb: 2 }}
        />

        <Input
          name="password"
          placeholder="Password"
          type="password"
          value={formData.password}
          onChange={handleChange}
          sx={{ mb: 2 }}
        />

        {/* <Input
            name="name"
            placeholder="Full Name"
            value={formData.name}
            onChange={handleChange}
            sx={{ mb: 2 }}
          />
          <Input
            name="country"
            placeholder="Country"
            value={formData.country}
            onChange={handleChange}
            sx={{ mb: 2 }}
          /> */}

        {/* Role selector */}
        <div style={{ display: "flex", gap: "1rem", marginBottom: "1rem" }}>
          <label>
            <input
              type="radio"
              name="role"
              value="worker"
              checked={formData.role === "worker"}
              onChange={handleChange}
            />
            &nbsp;Coder
          </label>
          <label>
            <input
              type="radio"
              name="role"
              value="raider"
              checked={formData.role === "raider"}
              onChange={handleChange}
            />
            &nbsp;MOTA
          </label>
        </div>

        {/* Show worker-only field */}
        {formData.role === "worker" && (
          <Input
            name="skillTags"
            placeholder="Skills (comma-separated, e.g., JavaScript, React)"
            value={formData.skillTags}
            onChange={handleChange}
            sx={{ mb: 2 }}
          />
        )}

        {/* Show raider-only fields */}
        {formData.role === "raider" && (
          <>
            <Input
              name="telegram"
              placeholder="Telegram username"
              value={formData.telegram}
              onChange={handleChange}
              sx={{ mb: 2 }}
            />
            <Input
              name="twitter"
              placeholder="Twitter / X handle"
              value={formData.twitter}
              onChange={handleChange}
              sx={{ mb: 2 }}
            />
            <Input
              name="phone"
              placeholder="Phone number"
              value={formData.phone}
              onChange={handleChange}
              sx={{ mb: 2 }}
            />
          </>
        )}

        <Input
          name="email"
          placeholder="Email"
          value={formData.email}
          onChange={handleChange}
          sx={{ mb: 2 }}
        />
        <Input
          name="password"
          placeholder="Password"
          type="password"
          value={formData.password}
          onChange={handleChange}
          sx={{ mb: 2 }}
        />

        <Button type="submit" fullWidth sx={{ mb: 2 }}>
          Register
        </Button>
      </form>

      {message && (
        <Typography
          color={message.includes("Error") ? "danger" : "success"}
          sx={{ mt: 2, textAlign: "center" }}
        >
          {message}
        </Typography>
      )}
      <Typography sx={{ textAlign: "center", mt: 2 }}>
        Already have an account?{" "}
        <Link component={RouterLink} to="/">
          Sign In
        </Link>
      </Typography>
    </Box>
  );
}